export default "__VITE_ASSET__9AApTLdA__"